<template>
  <div class="logo-container">
    <div @click="doShowPopup" class="logo-box">
      <div style="display: flex; flex-direction: column;">
        <div style="display: flex;">
          <img class="box-image" src="../assets/icons/voc_logo.png">
          <h2 class="text">The Dutch East<br>India Company (VOC)</h2>
        </div>
        <p class="text">Vereenigde Oostindische Compagnie</p>
      </div>
      <img class="glove" src="../assets/images/glove.png">
    </div>
  </div>
</template>

<script>
export default {
  name: "VOCLogo",
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {
    showPopup() {
      return this.$store.getters.getShowPopup
    },
    objects() {
      return this.$store.getters.getObjects
    }
  },
  methods: {
    doShowPopup() {
      this.$store.commit("setSelectedIndex", 0)
      this.$store.commit("setShowPopup", !this.showPopup)
    }
  }
};
</script>

<style scoped>
.logo-container {
  display: flex;
  align-items: center;
}
.logo-box {
  display: flex;
  align-items: center;
  text-align: left;
  width: 19.5em;
  height: 6.5em;
  color: var(--indigo);
  background-color: var(--light-blue);
  border: 1.25em solid var(--light-blue);
  border-radius: 0.25em;
  transition: 0.25s;
  pointer-events: auto;
  position: relative;
}
.logo-box:hover {
  background-color: var(--white);
  border: 1.25em solid var(--white);
  transition: 0.1s;
}
.text {
  white-space: nowrap;
  transition: 0.25s;
}
h2 {
  margin: 0.5em 0 0 0.5em;
  font-size: 1.4em;
}
p {
  margin: 0.5em 0 0 0.25em;
  font-size: 1.1em;
  color: var(--dark-blue);
}
.box-image {
  width: 4.5em;
  height: 4.5em;
  margin-top: 0;
  transition: 0.25s;
}
.glove {
  position: absolute;
  width: 4em;
  top: -2.5em;
  right: -2.25em;
  transition: 0.25s;
}
@media (max-width: 850px) {
  h2, p {
    opacity: 0;
    transition: 0.25s;
  }
  .logo-box {
    width: 4.5em;
    height: 4.5em;
    transition: 0.5s;
    transition-delay: 0.1s;
  }
  .box-image {
    margin-top: 1.5em;
  }
  .glove {
    opacity: 0;
  }
}
</style>